<template>
  <header>
    <nav>
      <router-link :to="{ name: 'main', params: {} }" class="logoBtn">
        <icon class="logo" size="xsmall" uicon="000" state="active"/>
        <span>스담</span>
        <!-- <img src="@/assets/icon/ico-logo-60.png"/> -->
      </router-link>
      <span>ePub2.0 Edite</span>
      <UbuttonList v-if="iconview" size="medium" :step="15" :data="buttonList"/>
      <span class="path">{{ path }}</span>
      <div class="right">
        <span class="require">해당 버전은 외부에서 접속을 할 수 없습니다.</span>
        <Ubutton size="medium" text="logout" state="deactive" @click.native="$emit('logout')"/>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  props: {
    iconview: { type: Boolean },
    file: { type: Object }
  },
  data: function () {
    return {
      buttonList: [
        {icon: '225', state: 'deactive', iconSize: 'small', click: () => { this.$emit('save') }},
        {icon: '224', state: 'deactive', iconSize: 'small', click: () => { this.$emit('load') }},
        {icon: '223', state: 'deactive', iconSize: 'small', click: () => { this.$emit('new') }}
      ]
    }
  },
  name: 'EditTop',
  components: {},
  computed: {
    path () {
      var st = ''
      if (this.file.drive) {
        st += '/' + this.file.drive.name
      }
      if (this.file && this.file.parent) {
        this.file.parent.forEach((n) => {
          st += '/' + n.name
        })
      }
      if (this.file.filename) {
        st += '/' + this.file.filename + '.upb'
      }
      return st
    }
  },
  methods: {
    menuHandler (e) {
      console.log(e)
    },
    alertHandler (e) {
      console.log('submit', e)
    },
    calendarHandler (e) {
      console.log('calendarHandler', e)
    }
  }
}
</script>

<style scoped>
header {
  width: 100%;
  height: 55px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  vertical-align: middle;
  border-bottom: 1px solid var(--line-guide);
  z-index: 10;
}
header nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
}
header nav .right {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.logoBtn {
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 3;
  color: #44BBFF;
}
.logo + span {
  margin-left: 2px;
  font-size: 25px;
  font-weight: bold;
}
.logoBtn + span {
  margin-left: 10px;
  margin-right: 10px;
}
.topNav {
  position: absolute;
  top: 0;
  left:0px;
  display: flex;
  width: 100%;
  height: 55px;
  align-items: center;
  z-index: 2;
}
.topNavBtn {
  margin-left: 40px;
}
.path {
  margin-right: auto;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/EditTop.vue